import styled from 'styled-components';

import { getBodyFontWeight, getTypographyFontColor } from './helpers';

const Body03 = styled.p`
    font-family: ${ ({ theme }) => theme.type.regularFont };
    font-weight: ${ getBodyFontWeight };    
    color: ${ getTypographyFontColor };
    font-size: 13px;
    letter-spacing: 0;
    line-height: 20px;
`;

export default Body03;
